export default __webpack_public_path__ + "static/media/ic_app.25f21c6c.svg";